import { type OnInit, Component, ViewEncapsulation, DOCUMENT, inject, ElementRef } from '@angular/core';
import { RouterLink, Router } from '@angular/router';
import {FirebaseService} from '../core/services/firebase.service';
import {ModalService} from '../core/services/modal.service';
import {AuthService} from '../features/auth/_services/auth.service';

import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-nav-menu',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        '(document:click)': 'onClick($event)'
    },
    imports: [MatMenu, MatMenuItem, RouterLink, MatMenuTrigger]
})
export class NavMenuComponent implements OnInit {
  private document = inject<Document>(DOCUMENT);
  private _eref = inject(ElementRef);
  private router = inject(Router);
  private firebaseService = inject(FirebaseService);
  private authService = inject(AuthService);
  private modalService = inject(ModalService);

  isSidebarOpen = false;
  isUserLoggedIn = false;
  isAdminLoggedIn = false;

  onClick(event) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isSidebarOpen = false;
    }
  }


  ngOnInit() {
   this.authService.currentUser.subscribe(d => {
     this.isUserLoggedIn =  this.authService.isLoggedIn || (d !== null && d.emailVerified && !this.authService.admin.includes(d.email));
     this.isAdminLoggedIn = this.authService.isAdminLoggedIn || (d !== null && d.emailVerified && this.authService.admin.includes(d.email));
   });
  }

  logout() {
    this.authService.SignOut();
  }

  goToContactUs() {
    this.firebaseService.setViewPort('contact-us');
  }

  goToMenu(): void {
    this.router.navigate(['fullmenu', 'menuitem'], {skipLocationChange: true});
  }

  goToYoello() {
    this.document.location.href = 'https://pay.yoello.com/v/bddine';
  }

  goToFoodhub() {
    this.document.location.href = 'https://bddineonline.com.au/order-now';
  }
}

